import React from "react";
import { useTranslation } from "react-i18next";
import CheckboxGroup from "../../inputs/checkbox-group";

import Modal from "../../modal-new";
import ModalFooter from "../ModalFooter";
import SvgIcon from "../../SvgIcon";

const CustomFilters = ({
  exercises = [],
  customFilter = [],
  updateCustomFilter,
}) => {
  const { t } = useTranslation("coaching-portal");
  const allSelected = exercises.length === customFilter.length;

  const handleCheck = (e) => {
    const customFilter = [];
    Array.from(
      document.getElementsByClassName("custom-filter-checkbox")
    ).forEach((input) => {
      if (input.checked) {
        customFilter.push(input.value);
      }
    });

    updateCustomFilter("check", customFilter);
  };

  const handleSave = (e) => {
    e.preventDefault();
    updateCustomFilter();
  };

  const handleDiscard = (e) => {
    e.preventDefault();
    updateCustomFilter("discard");
  };

  const handleSelectAll = (e) => {
    e.preventDefault();
    let customFilter = [];
    // select all by copying the exercises arr, else deselect all by passing empty arr
    if (!allSelected) customFilter = exercises.slice();
    updateCustomFilter("check", customFilter);
  };

  return (
    <Modal
      toClear={["session", "week"]}
      className="Custom-Filters"
      title={t("customFilters.title")}
    >
      <div className="body">
        <CheckboxGroup
          name="customFilterExercises"
          values={customFilter}
          checkboxes={exercises}
          checkboxClass="custom-filter-checkbox"
          onChange={handleCheck}
        />
        <button onClick={handleSelectAll}>
          <SvgIcon
            src={`/img/new-icons/${
              allSelected ? "checked-square" : "unchecked-square"
            }.svg`}
          />
          {allSelected
            ? t("customFilters.deselectAll")
            : t("customFilters.selectAll")}
        </button>
      </div>

      <ModalFooter
        onClickButton={handleSave}
        onClickAltButton={handleDiscard}
        classNameAltButton="text-(--danger)!"
        buttonText={t("common:save")}
        altButtonText={t("common:discard")}
      />
    </Modal>
  );
};

export default CustomFilters;
